/**
 * Vue3 storefile:Velocity.PrimaryOffersites.Web\wwwroot\store\modules\ExpressPaymentSettings.js
 * make changes there also
 */
import { defineStore } from 'pinia';
import {
  PAYMENT_CONFIGURATION_DETAILS,
  PAYMENT_CONFIGURATION_DOWN_PAYMENT,
  SUMMARY_DATA_DETAILS,
  SUMMARY_INCENTIVES,
} from '../../../../../js/constants/expresspaymentconstants';
import {
  EXPRESS_CALL_PAYMENTS_DATA,
  EXPRESS_GET_CALCULATED_MONTHLY_PAYMENT,
  EXPRESS_GET_SELECTED_INCENTIVES,
  EXPRESS_GET_SELECTED_SUMMARY_DATA,
  EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT,
  EXPRESS_SET_SUMMARY_DATA,
} from '../../../../../store/types';
import {
  callTransactPayments,
  doWeNeedTaxForThePayment,
  frameSummaryPaymentsData,
} from '../../../Services/Payments/PaymentsService';
import { usePaymentSettingsStore } from '../../PaymentSettings/PaymentsettingsStore';
import { fireDrsTagManagerEvent } from '../../../Events/DRSEvents/DRSEventsService';
import {
  getMonthlyPayment,
  getTotalServiceProtectionPlans,
  getTransactTradeDetailsData,
} from '../../../Services/Payments/TransactSummaryService';
import { useTradeValuePageStore } from '../../TradeValueStore/TradeValuePage/TradeValuePageStore';
import { ExpressPayments } from '../../../Services/Payments/ExpressPayments';

export const useExpressCheckoutStore = defineStore('expresscheckoutstore', {
  state() {
    return {
      isZipCodeChangedManual: false,
      activePaymentTabs: [],
      activeTransactSections: {
        lease: [],
        finance: [],
        cash: [],
      },
      activeTransactSectionsLoaded: {
        lease: [],
        finance: [],
        cash: [],
      },
      selectedPaymentOption: '',
      transactSectionCurrentViewPort: TRANSACT_PAYMENT_SECTION,
      yourPriceData: '',
      paymentsEventFireObject: false,
      tradeBackClicked: false,
      dealDetails: '',
      tradeSliderValue: '',
      mainTradeValue: 0,
      showExpressCheckoutModal: false,
      appliedOptionsModal: window.isauthenticated === 'True',
      performSoftPull: false,
      paymentsLoaded: false,
      showLoading: false,
      paymentSettings: {
        lease: '',
        finance: '',
        cash: '',
      },
      serviceAndProtectionPlans: '',
      zipCodeSelected: {
        lease: '',
        finance: '',
        cash: '',
      },
      incentives: {
        lease: '',
        finance: '',
        cash: '',
      },
      creditScores: {
        lease: '',
        finance: '',
        cash: '',
      },
      summaryData: {
        lease: SUMMARY_DATA_DETAILS,
        finance: SUMMARY_DATA_DETAILS,
        cash: SUMMARY_DATA_DETAILS,
      },
      expressPaymentConfiguration: PAYMENT_CONFIGURATION_DETAILS,
      vehicleDetails: '',
      vehicleDetailsArray: [],
      regions: '',
      selectedCityIndex: '',
      taxZipCode: '',
      taxZipStateSelected: '',
      taxZipSelected: '',
      selectedCreditScore: 0,
      selectedTradeValue: 0,
      paymentsNotFoundError: {
        lease: '',
        cash: '',
        finance: '',
      },
      calculatePaymentsOnTabChanged: false,
      discountsIncentivesLoaded: {
        lease: false,
        finance: false,
        cash: false,
      },
      incentivesAmount: {
        lease: 0,
        finance: 0,
        cash: 0,
      },
      dummySelectedSliderValue: 0,
      tradeSelectedOptions: {
        type: '',
        value: '',
      },
      firstTimeTradeCall: true,
      stepsList: EXPRESS_PAYMENT_STEPS_DETAILS,
      currentVehicleDetails: '',
      creditScoreFormDetails: '',
      paymentLoadedOptions: [],
      checkboxClicked: false,
      scheduleDeliverySteps: 1,
      scheduleDeliveryData: {
        postData: {
          firstName: window?.userDetails?.firstname ? window.userDetails.firstname : '',
          lastName: window?.userDetails?.lastname ? window.userDetails.lastname : '',
          primaryEmailID: window?.userDetails?.email ? window.userDetails.email : '',
          primaryPhoneNumber: window?.userDetails?.phonenumber
            ? window.userDetails.phonenumber
            : '',
          zipCode: '',
        },
        consumerId: '',
        userPin: '',
        locationType: '',
        deliveryAddress: '',
        deliveryDateTime: '',
      },
      creditScoreBuyerFormData: {
        firstname: window?.userDetails?.firstname ? window.userDetails.firstname : '',
        lastname: window?.userDetails?.lastname ? window.userDetails.lastname : '',
        phonenumber: window?.userDetails?.phonenumber ? window.userDetails.phonenumber : '',
        email: window?.userDetails?.email ? window.userDetails.email : '',
        address_1: '',
        city: '',
        state: '',
        zip: '',
        birthday: '',
      },
      transact_enabled_sections: [],
      transact_sections: {
        [EXPRESS_SECTION_PAYMENT_BOX]: true,
        [EXPRESS_SECTION_INCENTIVES_BOX]: false,
        [EXPRESS_SECTION_TRADE_VALUES_BOX]: false,
        [EXPRESS_SECTION_CREDIT_SCORE_BOX]: false,
        [EXPRESS_SECTION_TAXES_BOX]: false,
        [EXPRESS_SECTION_SERVICE_PROTECTION_BOX]: false,
        [EXPRESS_SECTION_SCHEDULE_DELIVERY_BOX]: false,
      },
      tradeLeaseOptions: {
        turnLease: '',
        estimatedLease: '',
        remainingPayments: '',
        monthlyPayments: '',
      },
      expressSaveOffer: {
        stepCount: 1,
      },
      showExpressMailModal: false,
      isPaymentSectionCalculated: false,
      isTransactTradeStart: false,
      isTransactPaymentSectionStart: false,
      transactOpened: false,
      drsProgramCodes: '',
      mostRecentDrsActivity: '',
      accessoriesList: [],
      selectedAccessories: [],
      transactSaveOfferLogLeadItemId: '',
      showNavLinksOnTransact: true,
      transactPrintWindowVariables: '',
    };
  },
  getters: {
    [EXPRESS_GET_SELECTED_SUMMARY_DATA](state) {
      return state.summaryData[state.selectedPaymentOption];
    },
    [EXPRESS_GET_CALCULATED_MONTHLY_PAYMENT](state) {
      return getMonthlyPayment(state.summaryData, state.selectedPaymentOption);
    },
    [EXPRESS_GET_SELECTED_INCENTIVES]: (state) => {
      return state.summaryData[state.selectedPaymentOption.toLowerCase()][SUMMARY_INCENTIVES];
    },
  },
  actions: {
    [EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT](payload) {
      let stateData = JSON.parse(JSON.stringify(this.incentivesAmount));
      stateData[payload.type] = payload.value;
      this.incentivesAmount = stateData;
    },
    [EXPRESS_SET_SUMMARY_DATA](payload) {
      let stateData = JSON.parse(JSON.stringify(this.summaryData));
      if (payload.selectedPaymentOption) {
        stateData[payload.selectedPaymentOption][payload.type] = payload.value;
      } else {
        stateData[this.selectedPaymentOption][payload.type] = payload.value;
      }

      this.summaryData = stateData;
    },
    async [EXPRESS_CALL_PAYMENTS_DATA]() {
      this.isPaymentSectionCalculated = true;
      this.showLoading = true;
      this.paymentsLoaded = true;
      let response = '';
      const selectedPaymentOption = this.selectedPaymentOption;
      try {
        const withTax = doWeNeedTaxForThePayment(selectedPaymentOption);
        response = await callTransactPayments(selectedPaymentOption, withTax);
      } catch (e) {
        this.paymentsNotFoundError[selectedPaymentOption.toLowerCase()] =
          'We are having difficulty finding the Payments. Please try with other options';
        console.log(e);
      }
      const isPaymentCollectionAvailable = response?.paymentCollection?.length > 0;
      const paymentSettingsStore = usePaymentSettingsStore();
      paymentSettingsStore.expressPaymentsFeesData = '';
      if (response?.FeesAndTaxesCollection) {
        paymentSettingsStore.expressPaymentsFeesData = response.FeesAndTaxesCollection;
      }
      this.paymentsNotFoundError[selectedPaymentOption.toLowerCase()] = '';
      frameSummaryPaymentsData(response);

      if (isPaymentCollectionAvailable) {
        if (this.paymentsEventFireObject) {
          try {
            this.paymentsEventFireObject = false;
          } catch (e) {
            console.log(e);
          }
        }
      }
      this.paymentsLoaded = true;
      this.showLoading = false;
      if (this.showExpressCheckoutModal) {
        fireDrsTagManagerEvent('DRS-Payment-Calculator');
      }
      try {
        const {
          scheduleDeliveryData,
          selectedPaymentOption,
          expressPaymentConfiguration,
          dummySelectedSliderValue,
          selectedCreditScore,
          creditScoreBuyerFormData,
          performSoftPull,
          creditScoreFormDetails,
          regions,
          selectedCityIndex,
          taxZipCode,
          tradeSelectedOptions,
          tradeLeaseOptions,
        } = this;
        const summaryData = this[EXPRESS_GET_SELECTED_SUMMARY_DATA];
        const monthlyPayment = this[EXPRESS_GET_CALCULATED_MONTHLY_PAYMENT];
        const selectedIncentives = this[EXPRESS_GET_SELECTED_INCENTIVES];

        const { vehicledetails, blackbookfilterdata } = useTradeValuePageStore();

        const postData = {
          dealsDto: {
            sessionId: window.tid,
            isActive: false,
            dealerId: window.accountId,
            campaignId: window.campaignId,
            pin: scheduleDeliveryData.userPin,
            vin: window.paymentsvin,
            paymentType: selectedPaymentOption,
            downPayment: expressPaymentConfiguration[PAYMENT_CONFIGURATION_DOWN_PAYMENT],
            incentivesApplied: summaryData.paymentData.IncentiveCash,
            tradeYear: vehicledetails.year,
            tradeMake: vehicledetails.make,
            tradeModel: vehicledetails.model,
            tradeTrim: vehicledetails.trim,
            tradeStyle: blackbookfilterdata.style,
            tradeMileage: blackbookfilterdata.miles,
            tradeValue: '', //Need to know
            equity: dummySelectedSliderValue,
            appliedTrade: summaryData.paymentData.TradeEquity,
            cashBack: summaryData.paymentData.Cashback,
            creditScore: selectedCreditScore,
            performedSoftPull: performSoftPull,
            firstName: creditScoreBuyerFormData.firstname,
            lastName: creditScoreBuyerFormData.lastname,
            phone: creditScoreBuyerFormData.phonenumber,
            email: creditScoreBuyerFormData.email,
            address: creditScoreBuyerFormData.address_1,
            city: creditScoreBuyerFormData.city,
            state: creditScoreBuyerFormData.state,
            zip: creditScoreBuyerFormData.zip,
            dobDay: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[0]
              : '',
            dobMonth: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[1]
              : '',
            dobYear: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[2]
              : '',
            taxesZipCode: taxZipCode,
            taxesRegion:
              regions && selectedCityIndex && regions[selectedCityIndex]
                ? regions[selectedCityIndex].City +
                  ' ' +
                  regions[selectedCityIndex].State +
                  ' ' +
                  regions[selectedCityIndex].County
                : '',
            servicePlansApplied: getTotalServiceProtectionPlans(summaryData),
            scheduleDateTime: scheduleDeliveryData.deliveryDateTime
              ? new Date(scheduleDeliveryData.deliveryDateTime).toISOString()
              : '',
            delivaryAddress: scheduleDeliveryData.delivaryAddress,
            delivaryLocation: scheduleDeliveryData.locationType,
            coordinatorName: creditScoreFormDetails.deliveryCordinatorName,
            coordinatorEmail: creditScoreFormDetails.deliveryCordinatorEmail,
            coordinatorPhone: creditScoreFormDetails.deliveryCordinatorPhoneNumber,
            paymentDetails: JSON.stringify(summaryData.paymentData),
            cFirstName: scheduleDeliveryData.postData.firstName,
            cLastName: scheduleDeliveryData.postData.lastName,
            cEmail: scheduleDeliveryData.postData.primaryEmailID,
            cPhoneNumber: scheduleDeliveryData.postData.primaryPhoneNumber,
            cZipCode: scheduleDeliveryData.postData.zipCode,
            monthlyPayment: monthlyPayment.toFixed(2),
            serviceProtectionPlansValue:
              ExpressPayments.getTotalServiceProtectionPlans(summaryData),
            vdpAccountId: window.vdpAccountId ? window.vdpAccountId : 0,
          },

          dealIncentivesDtos:
            selectedIncentives && selectedIncentives.length > 0 ? selectedIncentives : [],
          dealServicePlansDtos:
            summaryData.serviceProtectionPlan && summaryData.serviceProtectionPlan.length > 0
              ? summaryData.serviceProtectionPlan
              : [],
        };

        if (tradeSelectedOptions.type) {
          if (tradeSelectedOptions.type.toLowerCase() === 'leased') {
            if (tradeLeaseOptions.turnLease === 'Turn in my lease early') {
              postData.dealsDto.LeasePayoffCurrentMonthlyPayment =
                tradeLeaseOptions.monthlyPayments;
              postData.dealsDto.leasePayoffRemainingPayment = tradeLeaseOptions.remainingPayments;
              postData.dealsDto.leasePayoffOption = tradeLeaseOptions.turnLease;
            } else if (tradeLeaseOptions.turnLease === 'Buy out my lease') {
              postData.dealsDto.leasePayoffOption = tradeLeaseOptions.turnLease;
              postData.dealsDto.leasePayOffValue = tradeLeaseOptions.estimatedLease;
            } else {
              // No action needed for other cases.
            }
          }

          if (tradeSelectedOptions.type.toLowerCase() === 'financed') {
            postData.dealsDto.financePayOffValue = tradeSelectedOptions.value;
          }
        }

        const tradeDetails = getTransactTradeDetailsData();

        if (tradeDetails?.TradeYear) {
          postData.dealsDto.tradeYear = tradeDetails.TradeYear;
          postData.dealsDto.tradeMake = tradeDetails.TradeMake;
          postData.dealsDto.tradeModel = tradeDetails.TradeModel;
          postData.dealsDto.tradeTrim = tradeDetails.TradeTrim;
          postData.dealsDto.tradeMileage = tradeDetails.TradeMileage;
        }
        axios
          .post(`${window.ApiBaseUrl}/TransactDeals/SaveDeal`, postData)
          .then(() => {})
          .catch((err) => {
            console.log(err);
          });
      } catch (e) {
        console.log(e);
      }
    },

    summaryDataForCash(payload) {
      let stateData = JSON.parse(JSON.stringify(this.summaryData));
      stateData['cash'][payload.type] = payload.value;
      this.summaryData = stateData;
    },
  },
});
